module.exports = __webpack_public_path__ + "media/images/icons/v2/message-question-circle-31d798a9093f5fd8d36f996c2e2c78b4.svg";